/* OCCASORIA: animaciones de entrada, cuenta atrás de la campaña y galería de producto */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.oc-reveal:not(.oc-in)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('oc-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('oc-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }

  // Cuenta atrás hasta la fecha del evento (data-oc-countdown="2026-10-31T23:59:00")
  function initCountdown(root) {
    (root || document).querySelectorAll('[data-oc-countdown]').forEach(function (box) {
      var end = new Date(box.getAttribute('data-oc-countdown')).getTime();
      if (isNaN(end)) { box.hidden = true; return; }
      var f = { d: box.querySelector('[data-d]'), h: box.querySelector('[data-h]'), m: box.querySelector('[data-m]'), s: box.querySelector('[data-s]') };
      function tick() {
        var t = Math.max(0, end - Date.now());
        if (t === 0) { box.hidden = true; return; }
        f.d.textContent = Math.floor(t / 864e5);
        f.h.textContent = String(Math.floor(t / 36e5) % 24).padStart(2, '0');
        f.m.textContent = String(Math.floor(t / 6e4) % 60).padStart(2, '0');
        f.s.textContent = String(Math.floor(t / 1e3) % 60).padStart(2, '0');
      }
      tick(); setInterval(tick, 1000);
    });
  }

  // Galería de la página de producto
  function initGallery(root) {
    (root || document).querySelectorAll('[data-oc-gallery]').forEach(function (g) {
      var main = g.querySelector('[data-oc-main]');
      g.querySelectorAll('[data-oc-thumb]').forEach(function (b) {
        b.addEventListener('click', function () {
          g.querySelectorAll('[data-oc-thumb]').forEach(function (x) { x.classList.remove('is-on'); });
          b.classList.add('is-on');
          main.style.opacity = 0;
          setTimeout(function () { main.src = b.getAttribute('data-oc-thumb'); main.style.opacity = 1; }, 180);
        });
      });
    });
  }

  // Selector de variantes + cantidad
  function initBuy(root) {
    (root || document).querySelectorAll('[data-oc-buy]').forEach(function (form) {
      var data = form.querySelector('[data-oc-variants]');
      var variants = data ? JSON.parse(data.textContent) : [];
      var idInput = form.querySelector('input[name="id"]');
      var price = document.querySelector('[data-oc-price]');
      var btn = form.querySelector('button[type="submit"]');
      var selects = form.querySelectorAll('[data-oc-option]');
      function update() {
        var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
        var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === chosen[i]; }); });
        if (!v) return;
        idInput.value = v.id;
        if (price) price.innerHTML = v.price_html;
        btn.disabled = !v.available;
        btn.querySelector('span').textContent = v.available ? btn.getAttribute('data-add') : btn.getAttribute('data-soldout');
      }
      selects.forEach(function (s) { s.addEventListener('change', update); });
      var q = form.querySelector('input[name="quantity"]');
      form.querySelectorAll('[data-oc-qty]').forEach(function (b) {
        b.addEventListener('click', function () { q.value = Math.max(1, (parseInt(q.value, 10) || 1) + parseInt(b.getAttribute('data-oc-qty'), 10)); });
      });
    });
  }

  function init(root) { initReveal(root); initCountdown(root); initGallery(root); initBuy(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
